/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusSuccessDto } from '../../models/lexplus-success-dto';
import { LexplusThemenbereichDetailDto } from '../../models/lexplus-themenbereich-detail-dto';

export interface ThemenbereicheControllerUpdateV1$Params {
  isGrouped?: boolean;
      body: LexplusThemenbereichDetailDto
}

export function themenbereicheControllerUpdateV1(http: HttpClient, rootUrl: string, params: ThemenbereicheControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusSuccessDto>> {
  const rb = new RequestBuilder(rootUrl, themenbereicheControllerUpdateV1.PATH, 'patch');
  if (params) {
    rb.query('isGrouped', params.isGrouped, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusSuccessDto>;
    })
  );
}

themenbereicheControllerUpdateV1.PATH = '/v1/themenbereiche';
